import { useEffect } from 'react';

/**
 * Swipe from the left edge (x < 24px) → call onBack if drag > 80px rightward.
 * Swipe from the bottom edge (y > viewHeight - 40px) → call onHome if drag > 100px upward.
 */
export function useEdgeGestures(onBack: (() => void) | null, onHome: (() => void) | null) {
  useEffect(() => {
    if (!onBack && !onHome) return;

    let startX = 0;
    let startY = 0;
    let tracking: 'back' | 'home' | null = null;

    const onTouchStart = (e: TouchEvent) => {
      const t = e.touches[0];
      startX = t.clientX;
      startY = t.clientY;
      const vH = window.innerHeight;

      if (onBack && startX < 24) {
        tracking = 'back';
      } else if (onHome && startY > vH - 40) {
        tracking = 'home';
      } else {
        tracking = null;
      }
    };

    const onTouchEnd = (e: TouchEvent) => {
      if (!tracking) return;
      const t = e.changedTouches[0];
      const dx = t.clientX - startX;
      const dy = t.clientY - startY;

      if (tracking === 'back' && dx > 80 && Math.abs(dy) < 60) {
        onBack?.();
      } else if (tracking === 'home' && dy < -100 && Math.abs(dx) < 60) {
        onHome?.();
      }
      tracking = null;
    };

    document.addEventListener('touchstart', onTouchStart, { passive: true });
    document.addEventListener('touchend', onTouchEnd, { passive: true });
    return () => {
      document.removeEventListener('touchstart', onTouchStart);
      document.removeEventListener('touchend', onTouchEnd);
    };
  }, [onBack, onHome]);
}
